import { Controller } from '@hotwired/stimulus'

// Warns before leaving a form that has unsubmitted input. beforeunload covers browser
// navigation (Back/Forward, swipe gestures, reload, tab close); turbo:before-visit covers
// in-app links. Arms on the first interaction, not on mount, so merely opening the form
// never nags; disarms on submit and on `unsaved-changes:remove` (the session-timeout redirect).
export default class extends Controller {
  static values = {
    message: { type: String, default: 'You have not submitted this yet. Close anyway?' }
  }

  connect() {
    // A 422 re-render comes back with the answers still selected — stay armed.
    this.armed = Boolean(this.element.querySelector('input:checked'))

    window.addEventListener('beforeunload', this.beforeUnload)
    window.addEventListener('turbo:before-visit', this.beforeVisit)
    window.addEventListener('unsaved-changes:remove', this.disarm)
  }

  disconnect() {
    window.removeEventListener('beforeunload', this.beforeUnload)
    window.removeEventListener('turbo:before-visit', this.beforeVisit)
    window.removeEventListener('unsaved-changes:remove', this.disarm)
  }

  arm = () => {
    this.armed = true
  }

  disarm = () => {
    this.armed = false
  }

  // Closing the hosting drawer discards the form — reopening refetches a blank one — so
  // it needs the same confirmation as leaving. Vetoing the sidebar's cancelable
  // before-close covers its close button, Escape and the toggle in one place. Other
  // sidebars on the page are none of our business.
  sidebarClosing(event) {
    if (!this.armed) return
    if (!event.detail?.sidebar?.contains(this.element)) return

    if (window.confirm(this.messageValue)) this.disarm()
    else event.preventDefault()
  }

  beforeVisit = event => {
    if (!this.armed) return
    if (!window.confirm(this.messageValue)) event.preventDefault()
  }

  beforeUnload = event => {
    if (!this.armed) return
    event.preventDefault()
    // Browsers require both preventDefault() and a returnValue to show the dialog
    event.returnValue = ''
  }
}
